/**
 * Formules tarifaires présentées sur la page publique.
 * Montants en francs guinéens (FG). Contenu éditorial, modifiable librement.
 */

import type { SchoolPlan } from "@/types";

export const pricingPlans = [
  {
    id: "essentiel",
    plan: "ESSENTIEL" as SchoolPlan,
    name: "Essentiel",
    tagline: "Pour une école à cycle unique",
    price: 2000000,
    priceSuffix: "FG / an",
    popular: false,
    features: [
      "1 cycle au choix (Primaire ou Secondaire)",
      "Jusqu'à 400 élèves",
      "2 comptes utilisateurs",
      "Élèves, inscriptions et réinscriptions",
      "Paiements, reçus et restes à recouvrer",
      "Rapports financiers de base",
      "Fonctionne hors ligne (consultation, notes, paiements)",
    ],
    note: "Idéal pour démarrer la numérisation d'une petite école.",
  },
  {
    id: "etablissement",
    plan: "ETABLISSEMENT" as SchoolPlan,
    name: "Établissement",
    tagline: "Pour une école complète à deux cycles",
    price: 3900000,
    priceSuffix: "FG / an",
    popular: true,
    features: [
      "Primaire et Secondaire",
      "Élèves illimités",
      "Comptes utilisateurs illimités",
      "Finances par cycle, dépenses et salaires",
      "Charges prévisionnelles et contrôle budgétaire",
      "Personnel, enseignants et états de paie",
      "Documents et reçus imprimables en PDF",
      "Mode hors ligne et application installable",
    ],
    note: "Le choix des établissements qui veulent tout piloter au même endroit.",
  },
  {
    id: "reseau",
    plan: "RESEAU" as SchoolPlan,
    name: "Réseau",
    tagline: "Pour un groupe de plusieurs écoles",
    price: 0,
    priceSuffix: "Sur devis",
    popular: false,
    features: [
      "Plusieurs établissements sur une seule plateforme",
      "Chaque école avec tout le forfait Établissement",
      "Bilan comparatif des écoles (effectifs et finances) sur demande",
      "Cloisonnement strict des données par école",
      "Journal d'activité par établissement",
      "Rôles et permissions avancés",
      "Accompagnement et formation dédiés",
    ],
    note: "Tarif adapté au nombre d'écoles et d'élèves.",
  },
];

/** Questions fréquentes de la page publique. */
export const landingFaq = [
  {
    q: "Et quand la connexion est coupée ?",
    a: "WaitechEdu continue de fonctionner. L'application s'ouvre sans réseau, les données déjà chargées restent consultables et imprimables, et vous pouvez saisir des notes, des paiements et des inscriptions. Tout est envoyé automatiquement au retour de la connexion, sans jamais rien enregistrer deux fois. Le reçu numéroté d'un paiement s'imprime dès l'envoi. Le mode hors ligne fonctionne jusqu'à 3 jours sans connexion.",
  },
  {
    q: "Comment obtenir un compte pour mon école ?",
    a: "Il suffit de remplir le formulaire de demande depuis cette page. Seul l'administrateur de la plateforme peut valider l'ouverture : une fois approuvée, votre école est créée et vos identifiants sont activés.",
  },
  {
    q: "Qui valide les demandes d'ouverture de compte ?",
    a: "Les demandes sont examinées par l'administrateur de la plateforme. Le visiteur ne peut pas créer de compte lui-même : il dépose une demande, et l'administrateur l'approuve ou la refuse.",
  },
  {
    q: "Puis-je gérer plusieurs écoles dans la même plateforme ?",
    a: "Oui. Avec la formule Réseau, chaque établissement a son propre espace complet, et WaitechEdu vous fournit sur demande un bilan comparatif des effectifs et des finances de vos écoles.",
  },
  {
    q: "Les données sont-elles isolées entre les écoles ?",
    a: "Oui. Chaque école ne voit que ses propres données : les utilisateurs d'école sont verrouillés sur leur établissement, alors que l'administrateur de la plateforme peut basculer d'une école à l'autre.",
  },
  {
    q: "Faut-il installer un logiciel ?",
    a: "Non. Tout fonctionne dans le navigateur, sur ordinateur, tablette ou téléphone. L'application est en français ; les montants s'affichent en francs guinéens, ou dans la devise choisie par l'école.",
  },
];